module.exports = __webpack_public_path__ + "static/media/article-default.79fcb051.jpg";